import controller from './thing-description.controller';

const template = require('./thing-description.html');

export default {
    bindings: {
        description: '<',
        onUpdate: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-description/thing-description.component.js